import { type ClipboardEvent,type ComponentProps, type FC, type KeyboardEvent, type WheelEvent } from 'react';

import TextInputField from '../TextInputField/TextInputField';

type IntegerFieldProps = ComponentProps<typeof TextInputField>;

const IntegerField: FC<IntegerFieldProps> = ({ ...restProps }) => {
    const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
        if (['e', 'E', '+', '-', '.', ','].includes(e.key)) {
            e.preventDefault();
        }
    };

    const handlePaste = (e: ClipboardEvent<HTMLInputElement>) => {
        const pasted = e.clipboardData.getData('text');
        if (!/^\d+$/.test(pasted)) {
            e.preventDefault();
        }
    };

    const handleWheel = (e: WheelEvent<HTMLInputElement>) => {
        e.currentTarget.blur();
    };

    return (
        <TextInputField
            {...restProps}
            type="number"
            onKeyDown={handleKeyDown}
            onPaste={handlePaste}
            inputProps={{
                inputMode: 'numeric',
                pattern: '[0-9]*',
                onWheel: handleWheel,
                style: {
                    MozAppearance: 'textfield',
                },
            }}
            sx={{
                '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
                    WebkitAppearance: 'none',
                    margin: 0,
                },
            }}
        />
    );
};

export default IntegerField;
